import { FaBible, FaHandsHelping, FaChurch } from "react-icons/fa";

export default function BeliefsAndMinistries() {
  return (
    <section
      className="w-full bg-[#F5E9D8] text-[#1A1F2B] px-6 py-20 rounded-t-3xl"
      data-aos="fade-up"
    >
      <div className="max-w-6xl mx-auto space-y-16">

        {/* SECTION TITLE */}
        <div className="text-center max-w-3xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-bold">
            Our Beliefs, Commitment & Ministries
          </h2>
          <p className="mt-4 text-lg text-[#4A4A4A]">
            Rooted in Scripture, guided by faith, and committed to serving
            with love and integrity.
          </p>
        </div>

        {/* BELIEFS & COMMITMENT */}
        <div className="grid md:grid-cols-2 gap-10">

          {/* BELIEFS */}
          <div className="bg-white rounded-2xl p-8 shadow-md space-y-4">
            <div className="flex items-center gap-3">
              <FaBible className="text-[#D9A05B] text-2xl" />
              <h3 className="text-2xl font-semibold">Our Beliefs</h3>
            </div>

            <p className="text-lg leading-relaxed text-[#333]">
              We believe in the authority of the Bible, salvation through
              Jesus Christ, the work of the Holy Spirit, and the call to live
              a life of faith, holiness, and service.
            </p>
          </div>

          {/* COMMITMENT */}
          <div className="bg-white rounded-2xl p-8 shadow-md space-y-4">
            <div className="flex items-center gap-3">
              <FaHandsHelping className="text-[#D9A05B] text-2xl" />
              <h3 className="text-2xl font-semibold">Our Commitment</h3>
            </div>

            <ul className="space-y-3 text-lg list-disc list-inside text-[#333]">
              <li>Faithful teaching of sound doctrine</li>
              <li>Discipleship and leadership development</li>
              <li>Empowering the next generation</li>
              <li>Serving with love and integrity</li>
            </ul>
          </div>
        </div>

        {/* QUOTE */}
        <div className="text-center max-w-4xl mx-auto">
          <p className="text-xl md:text-2xl font-medium italic text-[#1A1F2B]">
            “Growing together in Christ, serving with love, and shining as a
            light to the world.”
          </p>
        </div>

        {/* MINISTRIES */}
        <div className="bg-white rounded-2xl p-10 shadow-md space-y-6">
          <div className="flex items-center gap-3">
            <FaChurch className="text-[#D9A05B] text-2xl" />
            <h3 className="text-2xl font-semibold">Our Ministries</h3>
          </div>

          <p className="text-lg leading-relaxed text-[#333] max-w-4xl">
            At Moriah Church, our ministries are designed to disciple believers,
            strengthen families, empower leaders, and impact the community for
            Christ. Each ministry serves a unique purpose while working
            together to fulfill God’s mission.
          </p>

          <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-4 text-lg">
            <span>• Sunday Worship Service</span>
            <span>• Youth Ministry</span>
            <span>• Women’s (Ladies) Ministry</span>
            <span>• Children’s Ministry / Sunday School</span>
            <span>• Discipleship & Leadership Development</span>
            <span>• Prayer Ministry</span>
            <span>• Community Outreach</span>
          </div>
        </div>
      </div>
    </section>
  );
}
